import { Page } from '@/core/architecture'

import { ProfileInputArtistTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ProfileInputArtist Page
 * Implemented as a practical sample.
 */
export const ProfileInputArtist: Page = () => {
  const { state, actions } = useViewModel()

  return <ProfileInputArtistTemplate state={state} {...actions} />
}
